module.exports = __webpack_public_path__ + "static/media/material-handling-equipment-distributors-association-mheda-vector-logo.71e3dd2b.png";